import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import DisciplinePage from "@/pages/DisciplinePage";
import ProjectDetail from "@/pages/ProjectDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/director" element={<DisciplinePage role="director" />} />
          <Route path="/production" element={<DisciplinePage role="producer" />} />
          <Route path="/writing" element={<DisciplinePage role="writer" />} />
          <Route path="/photography" element={<DisciplinePage role="photographer" />} />
          <Route path="/work" element={<Navigate to="/director" replace />} />
          <Route path="/work/:slug" element={<ProjectDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
